// extracted by mini-css-extract-plugin
export default {"container":"VoucherItem_container__yqQCj","voucher":"VoucherItem_voucher__ox+gJ","voucherImage":"VoucherItem_voucherImage__1p2SZ","reduce":"VoucherItem_reduce__CfbMd"};